import { createSelector } from 'reselect'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { getSelectedRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import VALUES from 'core/data-model/constants/values'

export const isProductForReuseFlexiHealth = (displayProduct) => {
  return VALUES.PRODUCT_CODE_FOR_REUSE_FLEXI_HEALTH.includes(displayProduct.code)
}

export const getProfileSummaryHeader = createSelector(
  getSelectedDisplayProduct,
  getSelectedRiders,
  (displayProduct, riders) => {
    const fhRider = riders.find((rider) => rider.code === VALUES.FH)

    const planName = fhRider
      ? // $$FlowFixMe
        isProductForReuseFlexiHealth(displayProduct)
        ? `(${displayProduct.basicPlanCode})`
        : `${fhRider.selectedPlan.plan} (${fhRider.selectedPlan.planCode})`
      : ''
    return `${displayProduct.name} ${planName}`
  }
)
